<template>
  <div class="white-border-wrapper flex items-center justify-center rounded-full p-2">
    <component
      :is="tag"
      v-bind="componentAttrs"
      :class="[
        'inline-flex text-3xl w-full items-center justify-center rounded-3xl border-0 px-16 py-2 transition-colors duration-200',
        'bg-accent text-white relative font-bold m-auto',
        'hover:bg-black hover:text-white focus:bg-black focus:text-white',
        'focus:outline-none',
        { 'cursor-pointer': tag === 'a' || tag === 'button' },
      ]"
    >
      <slot />
    </component>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  tag: {
    type: String,
    default: 'button',
  },
  href: String,
  type: {
    type: String,
    default: 'button',
  },
});

const componentAttrs = computed(() => {
  const attrs = {};
  if (props.tag === 'a' && props.href) {
    attrs.href = props.href;
  }
  if (props.tag === 'button') {
    attrs.type = props.type;
  }
  return attrs;
});
</script>

<style scoped></style>
